import { c as _c } from "react/compiler-runtime";
import { FileText } from "lucide-react";
import { Field, FieldLayout, hasConflicts } from "@/src/components/cards/common";
import EHRCard from "@/src/components/cards/ehr-cards/ehr-card";
import { EHRDocument } from "@/src/models/ehr-document";
const DOCUMENT_FIELDS: Field[] = [{
  key: "description",
  label: "Description",
  comparable: false
}, {
  key: "ehrId",
  label: "Document ID",
  comparable: false
}, {
  key: "createdAt",
  label: "Created Date",
  type: "datetime",
  comparable: false
}, {
  key: "status",
  label: "Status",
  comparable: false
}, {
  key: "documentDate",
  label: "Document Date",
  type: "date",
  comparable: true
}, {
  key: "assignedTo",
  label: "Assigned To",
  comparable: true
}, {
  key: "providerId",
  label: "Provider ID",
  comparable: true
}, {
  key: "internalNote",
  label: "Internal Note",
  comparable: true,
  colSpan: 2
}, {
  key: "actionNote",
  label: "Action Note",
  comparable: false,
  colSpan: 2
}];
interface EHRDocumentCardProps {
  document: EHRDocument | null;
  expectedDocument?: EHRDocument | null;
}
export default function EHRDocumentCard(t0) {
  const $ = _c(14);
  const {
    document,
    expectedDocument
  } = t0;
  let hasAnyConflicts = false;
  if (expectedDocument) {
    let t1;
    if ($[0] !== document || $[1] !== expectedDocument) {
      t1 = hasConflicts(DOCUMENT_FIELDS, document, expectedDocument);
      $[0] = document;
      $[1] = expectedDocument;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    hasAnyConflicts = t1;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FileText />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = document === null;
  let t3;
  if ($[4] !== document || $[5] !== expectedDocument) {
    t3 = document && <FieldLayout fields={DOCUMENT_FIELDS} patient={document} compareMode={expectedDocument !== null && expectedDocument !== undefined} secondaryObject={expectedDocument} compareAgainstTitle="Expected" />;
    $[4] = document;
    $[5] = expectedDocument;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== document) {
    t4 = !document && <p className="text-sm text-muted-foreground">No document information available</p>;
    $[7] = document;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== hasAnyConflicts || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <EHRCard icon={t1} title="Document Information" missingData={t2} hasAnyConflicts={hasAnyConflicts}>{t3}{t4}</EHRCard>;
    $[9] = hasAnyConflicts;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}